(function () {
  const STORAGE_KEY = 'amplifica-shipping-location';

  function safeJSONParse(value) {
    try {
      return JSON.parse(value);
    } catch {
      return null;
    }
  }

  async function updateCartAttributes(regionId, comunaId) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            amplifica_region_id: regionId || '',
            amplifica_comuna_id: comunaId || ''
          }
        })
      });
    } catch (err) {
      console.error('[Amplifica] Cart update failed', err);
    }
  }

  function syncAmplificaRegionToCart() {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return;

    const data = safeJSONParse(raw);
    if (!data || !data.regionId) return;

    const regionId = String(data.regionId);
    const comunaId = data.comunaId ? String(data.comunaId) : '';

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const currentRegion = cart.attributes?.amplifica_region_id || '';
        const currentComuna = cart.attributes?.amplifica_comuna_id || '';

        if (currentRegion !== regionId || currentComuna !== comunaId) {
          updateCartAttributes(regionId, comunaId);
        }
      })
      .catch(() => {
        updateCartAttributes(regionId, comunaId);
      });
  }

  document.addEventListener('DOMContentLoaded', syncAmplificaRegionToCart);

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) {
      syncAmplificaRegionToCart();
    }
  });
})();
